<template>
  <CadastroBase
    nomePlural="Usuarios"
    nomeSingular="Usuario"
    form-autocomplete="off"
    @headersLocation="setIdPessoaCriada($event)"
    @submitSuccessInsert="emitSubmitSuccess"
    @submitErrorInsert="emitSubmitError"
    @closeModalInsert="closeModal"
  >
    <ErrorAlert :errors="errors"></ErrorAlert>
    <v-col cols="12">
      <v-row>
        <template v-slot:conteudoModalSucesso>
          <v-card>
            <v-card-title>
              <div class="success rounded">
                {{ $t("cadastrado_sucesso") }}
              </div>

              <v-spacer />

              <v-icon aria-label="Close" @click="submited = false">
                mdi-close
              </v-icon>
            </v-card-title>
          </v-card>
        </template>

        <v-col cols="12">
          <v-row>
            <v-row>
              <v-col cols="12" md="12">
                <v-text-field
                  v-model="recurso.nome"
                  :label="$t('Nome')"
                  name="Nome"
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="recurso.cpf"
                  :label="$t('CPF')"
                  name="cpf"
                  v-mask="maskCpfCnpj(recurso.cpf)"
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  v-model="recurso.email"
                  :label="$t('Email')"
                  name="email"
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="2">
                <v-select
                  :items="[
                    { text: $t('Masculino'), value: 'MASCULINO' },
                    { text: $t('Feminino'), value: 'FEMININO' },
                    { text: $t('Não Binário'), value: 'NAO_BINARIO' },
                  ]"
                  :label="$t('Sexo')"
                  v-model="recurso.sexo"
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                ></v-select>
              </v-col>

              <v-col cols="12" md="12">
                <v-text-field
                  v-model="recurso.observacoes"
                  :label="$t('Observacao')"
                  name="email"
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                ></v-text-field>
              </v-col>

              <CampoTelefone
                @telefones="recurso.telefones = $event"
              ></CampoTelefone>
            </v-row>
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="recurso.cep"
                  :label="$t('CEP')"
                  @blur="buscaCep($event)"
                  v-mask="'##.###-###'"
                  name="cep"
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                />
              </v-col>

              <v-col cols="12" md="8">
                <v-autocomplete
                  :label="$t('Cidade')"
                  outlined
                  v-model="recurso.cidade"
                  :items="cidades"
                  :item-text="
                    (item) =>
                      item.nome +
                      (item.estado && item.estado.sigla
                        ? '/' + item.estado.sigla
                        : '')
                  "
                  return-object
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                >
                </v-autocomplete>
              </v-col>

              <v-col cols="12">
                <v-text-field
                  v-model="recurso.logradouro"
                  :label="$t('Logradouro')"
                  name="logradouro"
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                >
                </v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="recurso.numero"
                  :label="$t('Numero')"
                  name="numero"
                  type="number"
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                >
                </v-text-field>
              </v-col>

              <v-col cols="12" md="8">
                <v-text-field
                  v-model="recurso.bairro"
                  :label="$t('Bairro')"
                  name="bairro"
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                />
              </v-col>
              <v-col cols="12" md="12">
                <v-text-field
                  v-model="recurso.complementoEndereco"
                  :label="$t('Complemento')"
                  name="complemento"
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                />
              </v-col>
            </v-row>
          </v-row>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="recurso.senha"
            :label="$t('Senha')"
            name="senha"
            type="password"
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          />
        </v-col>

        <v-col cols="12">
          <InquilinosUsuarioPanel
            :value="recurso.inquilinos"
            :items="itensInquilinos"
            :min-selected="1"
            @input="atualizarInquilinosSelecionados"
          />
        </v-col>

        <v-col cols="12">
          <v-combobox
            v-model="recurso.perfis"
            :items="todosPerfis"
            item-text="descricao"
            return-object
            :label="$t('Perfis_do_usuario')"
            multiple
            chips
            deletable-chips
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          ></v-combobox>
        </v-col>
      </v-row>
    </v-col>
  </CadastroBase>
</template>

<script>
import UsuarioDataService from "@/services/acessos/UsuarioDataService";
const DataService = UsuarioDataService;

import CadastroBase from "@/components/base/Crud/CadastroBase";
import InquilinosUsuarioPanel from "@/components/acessos/Usuarios/InquilinosUsuarioPanel";
import { buscaCep } from "@/mixins/buscaCep";

export default {
  name: "CadastroUsuario",
  components: { CadastroBase, InquilinosUsuarioPanel },
  mixins: [buscaCep],
  data() {
    return {
      DataService: DataService,
      submited: false,
      recurso: {
        pessoa: {},
        email: "",
        senha: "",
        inquilino: this.$store.state.inquilino,
        inquilinos: [],
        perfis: [],
        cidade: {},
        logradouro: "",
        bairro: "",
      },
      pessoaUrl: {},
      senhaConfirma: "",
      todosPerfisDescricao: [],
      perfisSelecionados: [],
      todosPerfis: [],
      itensInquilinos: [],
      errors: [],
      pessoas: [],
      pessoa: [],
      search: "",
      headers: [
        { text: this.$t("Nome"), value: "nome", sortable: "false" },
        { text: this.$t("nRegistro"), value: "cpf", sortable: "false" },
      ],
      idPessoaCriada: 1,
    };
  },
  methods: {
    emitSubmitSuccess() {
      this.$emit("submitSuccessInsert");
    },
    emitSubmitError() {
      this.$emit("submitErrorInsert");
    },
    closeModal() {
      this.$emit("closeModalInsert");
    },

    senhaCoincide() {
      if (this.recurso.senha !== this.senhaConfirma) {
        this.errors = [
          { field: this.$t("senha"), message: this.$t("senhas_nao_conferem") },
        ];
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        return false;
      }
      return true;
    },

    findPerfis() {
      DataService.findPerfis()
        .then((response) => {
          this.todosPerfis = response.data;
        })
        .catch((error) => {
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
          console.log(error);
        });
    },

    carregarInquilinosDisponiveis() {
      return UsuarioDataService.find(this.$store.state.user.id)
        .then((response) => {
          this.itensInquilinos = Array.isArray(response.data?.inquilinos)
            ? response.data.inquilinos
            : [];
          this.garantirInquilinoAtualSelecionado();
        })
        .catch((error) => {
          console.log(error);
          this.itensInquilinos = this.$store?.state?.user?.inquilinos || [];
          this.garantirInquilinoAtualSelecionado();
        });
    },

    atualizarInquilinosSelecionados(inquilinos) {
      const selecionados = (Array.isArray(inquilinos) ? inquilinos : []).map(
        (item) => {
          return {
            inquilino: item?.inquilino || item,
          };
        }
      );
      this.recurso.inquilinos = selecionados;
      this.recurso.inquilino =
        selecionados[0]?.inquilino || this.$store.state.inquilino;
    },

    garantirInquilinoAtualSelecionado() {
      const inquilinoAtual = this.$store?.state?.inquilino;
      const idAtual = this.normalizarId(
        this.getItemInquilinoId(inquilinoAtual)
      );
      if (!idAtual || this.recurso.inquilinos.length > 0) {
        return;
      }

      const itemAtual = this.itensInquilinos.find((item) => {
        return this.normalizarId(this.getItemInquilinoId(item)) === idAtual;
      }) || { inquilino: inquilinoAtual };

      if (
        !this.itensInquilinos.some((item) => {
          return this.normalizarId(this.getItemInquilinoId(item)) === idAtual;
        })
      ) {
        this.itensInquilinos = [itemAtual, ...this.itensInquilinos];
      }

      this.atualizarInquilinosSelecionados([itemAtual]);
    },

    getItemInquilinoId(item) {
      return item?.inquilino?.id || item?.id || null;
    },

    normalizarId(id) {
      if (id === null || id === undefined || id === "") {
        return null;
      }
      return String(id);
    },
  },
  mounted() {
    this.garantirInquilinoAtualSelecionado();
    this.carregarInquilinosDisponiveis();
    this.findPerfis();
  },
};
</script>
<style scoped></style>
